var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout md-alignment-center-center"},[_c('div',{staticClass:"md-layout-item"},[_c('span',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }